/* TIFAPRO product page: bonus choice, add-ons, add-to-cart → checkout, previews, sticky bar. */
(() => {
  const root = document.querySelector('[data-tfp-root]');
  if (!root || root.dataset.tfpReady) return; // guard against double initialisation
  root.dataset.tfpReady = '1';

  const form = root.querySelector('[data-tfp-form]');
  const submit = root.querySelector('[data-tfp-submit]');
  const errorEl = root.querySelector('[data-tfp-error]');
  const radios = Array.from(root.querySelectorAll('input[name="id"][type="radio"]'));
  const addons = Array.from(root.querySelectorAll('[data-addon-index]'));

  const selectedRadio = () => radios.find((r) => r.checked);

  // Guide stages: all open on desktop; on phones keep only the first open.
  if (window.matchMedia('(max-width: 46rem)').matches) {
    root.querySelectorAll('[data-tfp-stage]').forEach((d, i) => { if (i > 0) d.open = false; });
  }

  const cards = Array.from(root.querySelectorAll('[data-tfp-card]'));
  const totalEls = root.querySelectorAll('[data-tfp-total]');
  const money = (cents) => '$' + (Number(cents) / 100).toFixed(2);
  const addonBox = (index) => {
    const label = addons.find((l) => l.dataset.addonIndex === String(index));
    return label ? label.querySelector('input') : null;
  };

  const syncTotal = () => {
    const r = selectedRadio();
    if (!r) return;
    let cents = Number(r.dataset.cents || 0);
    addons.forEach((label) => {
      const box = label.querySelector('input');
      if (!label.hidden && box.checked) cents += Number(box.dataset.cents || 0);
    });
    totalEls.forEach((el) => { el.textContent = money(cents); });
  };

  // Bonus cards mirror the form: one card is the free pick, the others offer the paid add-on.
  const syncCards = () => {
    const r = selectedRadio();
    cards.forEach((card) => {
      const idx = card.dataset.tfpCard;
      const isFree = !!r && r.dataset.index === idx;
      const radio = radios.find((x) => x.dataset.index === idx);
      const box = addonBox(idx);
      const state = card.querySelector('[data-tfp-state]');
      const pick = card.querySelector('[data-tfp-pick]');
      const add = card.querySelector('[data-tfp-add]');
      card.classList.toggle('is-free', isFree);
      card.classList.toggle('is-added', !isFree && !!box && box.checked);
      if (state) {
        state.textContent = isFree ? 'بونصك المجاني ✓' : (box && box.checked ? 'مضاف كإضافة مدفوعة' : 'إضافة اختيارية');
      }
      if (pick) pick.hidden = isFree || !radio || radio.disabled;
      if (add) {
        add.hidden = isFree || !box;
        if (add.dataset.label === undefined) add.dataset.label = add.innerHTML;
        if (box) add.innerHTML = box.checked ? 'إزالة الإضافة' : add.dataset.label;
        add.setAttribute('aria-pressed', String(!!box && box.checked));
      }
    });
  };

  const syncChoice = () => {
    const r = selectedRadio();
    if (!r) return;
    root.querySelectorAll('[data-tfp-price]').forEach((el) => { el.textContent = r.dataset.price; });
    root.querySelectorAll('[data-tfp-compare]').forEach((el) => {
      el.textContent = r.dataset.compare || '';
      el.hidden = !r.dataset.compare;
    });
    // The chosen free bonus cannot also be bought as an add-on.
    addons.forEach((label) => {
      const same = label.dataset.addonIndex === r.dataset.index;
      label.hidden = same;
      if (same) label.querySelector('input').checked = false;
    });
    syncTotal();
    syncCards();
  };

  radios.forEach((r) => r.addEventListener('change', syncChoice));
  addons.forEach((label) => label.querySelector('input').addEventListener('change', () => { syncTotal(); syncCards(); }));
  syncChoice();

  const goBuy = () => document.getElementById('buy')?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  // "Choose as free bonus" buttons in the bonus cards.
  root.querySelectorAll('[data-tfp-pick]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = radios.find((r) => r.dataset.index === btn.dataset.tfpPick);
      if (target && !target.disabled) {
        target.checked = true;
        syncChoice();
      }
      goBuy();
    });
  });

  // "Add for $7" buttons toggle the matching add-on checkbox.
  root.querySelectorAll('[data-tfp-add]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const box = addonBox(btn.dataset.tfpAdd);
      if (!box) return;
      box.checked = !box.checked;
      syncTotal();
      syncCards();
    });
  });

  // Add main variant + selected add-ons in one request, then go to checkout.
  if (form && submit) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const main = selectedRadio()?.value || form.querySelector('input[name="id"]')?.value;
      if (!main) return;
      const items = [{ id: Number(main), quantity: 1 }];
      addons.forEach((label) => {
        const box = label.querySelector('input');
        if (!label.hidden && box.checked) items.push({ id: Number(box.value), quantity: 1 });
      });

      const original = submit.innerHTML;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      if (errorEl) errorEl.hidden = true;

      try {
        // Start from an empty cart so a second click never doubles the guide.
        await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('cart');
        window.location.assign(form.dataset.checkoutUrl || '/checkout');
      } catch (e) {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        submit.innerHTML = original;
        if (errorEl) errorEl.hidden = false;
      }
    });
  }

  // Jump links to the buy box.
  root.querySelectorAll('[data-tfp-goto]').forEach((a) => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      goBuy();
    });
  });

  // Preview lightbox.
  const box = root.querySelector('[data-tfp-lightbox]');
  const boxImg = root.querySelector('[data-tfp-lightbox-img]');
  if (box && boxImg && typeof box.showModal === 'function') {
    root.querySelectorAll('.tfp-preview__btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const img = btn.querySelector('img');
        boxImg.src = btn.dataset.full;
        boxImg.alt = img ? img.alt : '';
        box.showModal();
      });
    });
    box.querySelector('[data-tfp-close]')?.addEventListener('click', () => box.close());
    box.addEventListener('click', (e) => { if (e.target === box) box.close(); });
  }

  // Sticky mobile buy bar: visible when the buy box is off-screen.
  const sticky = root.querySelector('[data-tfp-sticky]');
  const buy = root.querySelector('[data-tfp-buy]');
  const finalCta = root.querySelector('.tfp-final');
  if (sticky && buy && 'IntersectionObserver' in window) {
    const seen = new Map();
    const update = () => {
      const show = !seen.get(buy) && !seen.get(finalCta) && window.scrollY > 200;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.querySelector('a')?.setAttribute('tabindex', show ? '0' : '-1');
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => seen.set(en.target, en.isIntersecting));
      update();
    });
    io.observe(buy);
    if (finalCta) io.observe(finalCta);
  }
})();
